// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3GmzS","overflowing":"ReadFullNote_overflowing__16Vu1"};